module.exports = __webpack_public_path__ + "img/side invisible zipper length.dc14064c.png";